module.exports = __webpack_public_path__ + "media/images/icon_list/map_pin-77ba8e9c0dcc5a14f18023ce191b997e.svg";